declare namespace $ {

	type $mol_view__sub_shm_hitalama_resilience_page_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_resilience_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_resilience_page['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_hitalama_resilience_page_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_resilience_page['details'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_shm_hitalama_resilience_page_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_resilience_page_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_resilience_page['retry'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_resilience_page_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_resilience_page['retry_controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_resilience_page_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_resilience_page extends $mol_page {
		Title( ): $mol_view
		Message( ): $mol_text
		Details( ): $mol_text
		retry( next?: any ): any
		Retry( ): $mol_button_major
		retry_controls( ): readonly(any)[]
		Retry_visible( ): $mol_view
		Content( ): $mol_view
		title( ): string
		message( ): string
		details( ): string
		retry_visible( ): boolean
		head( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map